import { createContext, useContext } from 'react';

type DpFanInitialStageContextType = {
	onStart: () => void;
	onClose: () => void;
};

export const DpFanInitialStageContext = createContext<DpFanInitialStageContextType | null>(null);

export const DpFanInitialStageProvider = DpFanInitialStageContext.Provider;

export const useDpFanInitialStageContext = () => {
	const context = useContext(DpFanInitialStageContext);

	if (!context) {
		throw new Error(
			'useDpFanInitialStageContext must be used within a DpFanInitialStageProvider'
		);
	}
	return context;
};
